import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class AuthRedirectGuard implements CanActivate {
  constructor(
    private msal: MsalService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    return this.msal.instance.getAllAccounts().length > 0 ? true : this.router.parseUrl('/auth');
  }
}
